import { __, getContrastColor, getDomainName } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingCategory, ILandingSection, ILink, LANDING_TYPE_CONTENT, LinksFeedContent, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import ItemEditForm from "../../landing-edit/editors/ItemEditForm"
import { ID, POST_STATUS } from "src/libs/interfaces/layouts"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { Fragment, useEffect, useState } from "react"
import { Button, ButtonVariant, Icon, Popover, Position, Tag } from "@blueprintjs/core"
import { getColumnClassName } from "src/libs/utilities/layout"
import RatingHandler from "src/libs/useful/RatingHandler"
import { IUser } from "src/settings/zustand"
import updateSection from "../../landing-edit/utils/updateSection"
import { LINK_POST_TYPES } from "../LinksFeedPrimitive"
import { Hint } from "src/libs/useful"

/* Protopia Ecosystem component */

export const THUMBNAIL_SIZE = 120

export const getAvrRating = (rating: any[]): number => {
    return !!( rating || [] ).length ? ( rating || [] ).reduce(( sum, res ) => sum + res.rating, 0) / ( rating || [] ).length : 0
}
export interface ISingleLinkProps {
    primitive: LinksFeedContent
    data: ILink
    i: number
    items: ILink[]
    columns: number
    section?: ILandingSection
    onChange: (value: any, field: string,) => void
}
const SingleLink = (props: ISingleLinkProps): JSX.Element => {
    const [categories, setCats] = useState<ILandingCategory[]>( [] )
    const [rating, setRating] = useState<any[]>( props.data.rating || [] )
    const [isRatingUpdate, setIsRatingUpdate] = useState<boolean>( false )
    const [avRating, setAvRating] = useState<number>( getAvrRating(props.data.rating || []) )

    useEffect(() => {
        const cats = useLandingStore.getState().currentLanding?.categories || []
        setCats(cats)
        setRating( props.data.rating || [] )
        setAvRating( getAvrRating(props.data.rating || []) )
    }, [ props.data.categoryId, props.data.rating ])

    const getCategory = (id: ID): ILandingCategory | undefined => {
        return categories.find( c => c.id === id )
    }

    const onStatus = ( evt: any, status: POST_STATUS ) => {
        props.onChange( status, "status" )
        evt.stopPropagation()
        evt.preventDefault()
    }

    const onAdd = ( sectionId: ID, order: number ) => {
        useLandingStore.setState({
            curEditModal: {
                currentEditType: SELECT_TYPE.LINK_ITEM,
                sectionId,
                order,
                isNew: true
            }
        })
    }
    const onRating = (user: IUser, rate: number) => {
        const newRatingData : any[] = !!rating.filter( r => r.user?.id === user.id).length
            ?
            rating.map( r => {
                if(r.user?.id === user.id) {
                    return {
                        ...r,
                        rating: rate
                    }
                }
                return r
            })
            :
            [ 
                ...rating, 
                { 
                    user, 
                    rating: rate 
                } 
            ]
        setRating( newRatingData )
        setAvRating( getAvrRating( newRatingData ) ) 

        /** */
        if(!props.section) return
        const section: ILandingSection = JSON.parse( JSON.stringify( {
            ...props.section,
            data: props.section.data.map( meat => {
                if( meat.id === props.primitive.id ) {
                    return {
                        ...meat,
                        items: meat.items.map((item: ILink, i: number) => {
                            if( item.url === props.items[ props.i ].url ) {
                                return {
                                    ...item,
                                    rating: newRatingData
                                }
                            }
                            return item
                        })
                    }
                }
                return meat
            })
        } )) 
        const historyStep : IHistoryStep = {
            data: section,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title: "Update link's rating",
        } 
        setIsRatingUpdate(true)
        updateSection( section, historyStep, true, () => setIsRatingUpdate(false) )
    }

    const col = getColumnClassName( props.columns )
    
    return <div className={`pe-single-link-container mb-3 position-relative d-flex w-100 flex-sm-column flex-lg-row align-items-start ${ col }`} >
        <ItemEditForm 
            i={ props.primitive.items.findIndex( item => item.url  === props.data.url ) } 
            primitive={ props.primitive } 
            items={ props.items } 
            itemType={ LANDING_TYPE_CONTENT.LINKS_FEED } 
            onAdd={ onAdd }
            section={ props.section }
        >
            <>
                <div
                    style={{
                        width: THUMBNAIL_SIZE, 
                        position: "relative", 
                        marginRight: 20,
                        marginBottom: 4,
                    }}
                >
                    <a
                        style={{
                            width: THUMBNAIL_SIZE, 
                            height: THUMBNAIL_SIZE,
                            display:"block",
                            position: "relative",
                            backgroundImage:`url(${ props.data.image })`,
                            backgroundSize: "cover",
                            backgroundPosition: "center", 
                            aspectRatio: 1,
                        }}
                        className={`${ props.data.status === POST_STATUS.DRAFT ? "opacity_5" : "" }`}
                        href={props.data.url} 
                        target="_blank" 
                        rel="noreferrer"                        
                    > 
                        
                    </a>
                    <RatingHandler 
                        rating={ rating }
                        current={ avRating } 
                        isLoading={ isRatingUpdate }
                        onChange={ onRating } 
                        size={ 10 } 
                        max={ 5 }
                        color={"var(--force-contrast-opacity-color"} 
                        activeColor={"var(--red"} 
                        className="mt-2" 
                    />
                    <div className="d-flex position-relative ">
                        {
                            LINK_POST_TYPES.map( key => <Hint label={ __( key.title ) } key={ key._id }>
                                <Button
                                variant={ ButtonVariant.MINIMAL }
                                icon={ key.icon } 
                                className={`mr-1 ${ props.data.status === key._id ? "" : "opacity_5"} `}
                                onClick={ (evt: any) => onStatus(evt, key._id) }
                            />
                            </Hint>)
                        }
                    </div>
                    
                </div>
                <div className={`w-100 ${ props.data.status === POST_STATUS.DRAFT ? "opacity_5" : "" } `}>
                    <a className="title mb-2" href={props.data.url} target="_blank" rel="noreferrer" dangerouslySetInnerHTML={{__html: props.data.title || ""}} />
                    <div>
                        { props.data.description }
                    </div>
                    <div className="d-flex justify-content-start mt-1">
                        { 
                            props.data.categoryId?.map((id, i) => {
                                const tag = getCategory( id )
                                return !!tag 
                                    ? 
                                    !!tag.content
                                        ?
                                        <Popover 
                                            key={ tag.id }
                                            position={ Position.TOP_LEFT }
                                            interactionKind="hover"
                                            hoverOpenDelay={ 750 }
                                            content={
                                                <div className="width-300 overflow-y-auto">
                                                    <div className="small p-4">
                                                        { tag.content }
                                                    </div>
                                                </div>
                                            }
                                        >
                                            <Tag style={{ backgroundColor: tag.color }} className="text-uppercase letter-spacing-2 px-2 py-1 mr-1 mb-1">
                                                <span style={{ color: getContrastColor( tag.color ) }} className="smallest" dangerouslySetInnerHTML={{__html: tag.title}} />
                                                <Icon icon="caret-down" size={12} className="ml-2" />
                                            </Tag>
                                        </Popover>
                                        :                              
                                        <Tag key={ tag.id } style={{ backgroundColor: tag.color }} className="text-uppercase letter-spacing-2 px-2 py-1 mr-1 mb-1">
                                            <span style={{ color: getContrastColor( tag.color ) }} className="smallest" dangerouslySetInnerHTML={{__html: tag.title}} />
                                        </Tag>  
                                    : 
                                    <Fragment key={ i } />
                            })
                        }
                    </div>
                    <div className="d-flex justify-content-start mt-1">
                        <a href={props.data.url} target="_blank" rel="noreferrer" >
                            <div className="small">{ getDomainName( props.data.url ) ||  __("Link")}</div>
                        </a>
                    </div>
                </div>
            </>
        </ItemEditForm>
    </div>
}
export default SingleLink